var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "74px",
    viewBox: "0 0 73 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-",
    transform: "translate(-1805.000000, -207.000000)",
    fill: "#4CD964",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verified",
    transform: "translate(1805.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3093496,10.8369531 C55.4154121,3.84872266 46.2494922,0 36.5,0 C26.7503652,0 17.5843027,3.84872266 10.6905078,10.8369531 C3.79657031,17.8253281 0,27.1169531 0,37 C0,46.8830469 3.79657031,56.1745273 10.6905078,63.1629023 C17.5844453,70.1512773 26.7503652,74 36.5,74 C46.2494922,74 55.4154121,70.1512773 62.3093496,63.1629023 C69.2032871,56.1745273 73,46.8830469 73,37 C73,27.1169531 69.2032871,17.8254727 62.3093496,10.8369531 Z M36.5,69.6640625 C18.7323418,69.6640625 4.27734375,55.0110508 4.27734375,37 C4.27734375,18.9889492 18.7323418,4.3359375 36.5,4.3359375 C54.2676582,4.3359375 68.7226563,18.9889492 68.7226563,37 C68.7226563,55.0110508 54.2676582,69.6640625 36.5,69.6640625 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3584815,24.6344298 C53.5032696,23.7884993 52.1164157,23.7884993 51.2612037,24.6345742 L31.9201552,43.7689834 L21.7389423,33.6965463 C20.8837303,32.8504714 19.4968765,32.8504714 18.6415185,33.6965463 C17.7861605,34.5426212 17.7861605,35.914658 18.6415185,36.7608773 L30.3713703,48.3654077 C30.7990493,48.7885174 31.3596023,49 31.9200092,49 C32.4804162,49 33.0411152,48.7883729 33.4686481,48.3654077 L54.3584815,27.6987608 C55.2138395,26.8526859 55.2138395,25.4806491 54.3584815,24.6344298 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f89b223061efb7d99bae324092aabfa7.svg";
export { ForwardRef as ReactComponent };